import type { TransientResultFile, TransientResultFolder } from "./formatJobResults";
import type { StoredFile } from "./storedDirectory";

import { folderNameForFile } from "./formatJobResults";
import { lastPathSegment } from "./storedDirectory";

const addFile = (byFolder: Map<string, TransientResultFile[]>, folderName: string, file: TransientResultFile) => {
  const files = byFolder.get(folderName) ?? [];
  if (files.some((item) => item.name === file.name)) return;
  files.push(file);
  byFolder.set(folderName, files);
};

export const collectResultFolders = (
  listing: {
    files: StoredFile[];
    folders: string[];
  },
  isMatch: (name: string) => boolean
): TransientResultFolder[] => {
  const byFolder = new Map<string, TransientResultFile[]>();
  listing.folders.forEach((folderName) => {
    byFolder.set(folderName, []);
  });
  listing.files.forEach((file) => {
    const name = lastPathSegment(file.name);
    if (!isMatch(name)) return;
    const folderName = folderNameForFile(file);
    if (!folderName) return;
    addFile(byFolder, folderName, { name, path: file.path, url: file.url });
  });
  return [...byFolder.entries()]
    .map(([folderName, files]) => ({
      files: files.slice().sort((a, b) => a.name.localeCompare(b.name)),
      folderName,
    }))
    .sort((a, b) => a.folderName.localeCompare(b.folderName));
};
